var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7417 10.3277C12.529 9.25247 12.9999 7.93181 12.9999 6.5001C12.9999 2.91614 10.0839 0.00012207 6.49996 0.00012207C2.91599 0.00012207 0 2.91614 0 6.5001C0 10.0841 2.91602 13.0001 6.49999 13.0001C7.93169 13.0001 9.25248 12.5291 10.3277 11.7417L14.586 16L16 14.586C16 14.5859 11.7417 10.3277 11.7417 10.3277ZM6.49999 11.0001C4.01854 11.0001 2.00001 8.98154 2.00001 6.5001C2.00001 4.01866 4.01854 2.00013 6.49999 2.00013C8.98143 2.00013 11 4.01866 11 6.5001C11 8.98154 8.9814 11.0001 6.49999 11.0001Z",
    fill: "#303743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.a67a2e34d3a7f334da2e3ff1852ac1bb.svg";
export { ForwardRef as ReactComponent };